module.exports = __webpack_public_path__ + "static/media/file-text-dynamic-premium.6d5c01e3.png";